import type { ChartLegendProps } from './types'

import { ColorIndicator, Label, LegendContainer, LegendItem } from './styles'

export function ChartLegend({ items, className = '' }: ChartLegendProps) {
  return (
    <LegendContainer className={className}>
      {items.map((item, index) => (
        <LegendItem key={`legend-item-${index}`}>
          <ColorIndicator color={item.color} />
          <Label>{item.label}</Label>
        </LegendItem>
      ))}
    </LegendContainer>
  )
}
